if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.modalGallery = new Swiper(this.querySelector('.product-media-modal__gallery'), {
        slidesPerView: 1,
        navigation: {
          nextEl: ".swiper-button-next--product-media-modal__gallery",
          prevEl: ".swiper-button-prev--product-media-modal__gallery",
        }
      });

      this.modalGallery.slides.forEach((slide, index) => {
        slide.setAttribute('data-index', index);
      });
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      let media = this.querySelectorAll(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      if (media.length > 1) {
        media.forEach(el => {
          if (el.dataset.imageVariantId == this.openedBy.dataset.variantImageId) {
            let activeMedia = el;
            this.showActiveMedia(activeMedia);
            let activeSlide = activeMedia.dataset.index;
            this.modalGallery.activeIndex = activeSlide;
            this.modalGallery.update();
          }
        })
      }else {
        let activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`)
        this.showActiveMedia(activeMedia);
        let visibleIndex = 0;
        this.modalGallery.slides.forEach((slide) => {
          if (slide.classList.contains('hidden')) {
            slide.setAttribute('data-index', -1);
          } else {
            slide.setAttribute('data-index', visibleIndex);
            visibleIndex++;
          }
        });
        let activeSlide = activeMedia.dataset.index;
        this.modalGallery.activeIndex = activeSlide;
        this.modalGallery.update();
        this.modalGallery.slideTo(activeSlide);
      }
    }

    showActiveMedia(activeMedia) {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.add('hidden');
        }
      )
      
        let activeMediaTemplate = activeMedia.querySelector('template');
        let activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          if (element.dataset.imageVariantId == activeMedia.dataset.imageVariantId) {
            element.classList.remove('hidden');
          }
          if (element.dataset.mainMedia == 'true') {
            element.classList.remove('hidden');
          }
        })
        activeMedia.classList.remove('hidden');
  
        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
  
        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
    }
  });
}
